import BaseServices from "./BaseServices";

const AccountServices = {
    OAuthDialogSocial: async (social) => {
        return await BaseServices.Get(`/api/accounts/oauth-dialog-artist-social?social=${social}`);
    },
    LoginSocial: async (param, social, ruuid, urlCallback) => {
        return await BaseServices.Get(`/api/accounts/login-artist-social` + param + "&social=" + social + `&ruuid=${ruuid}&urlCallback=${urlCallback}`);
    },
};

export default AccountServices;



// WEBPACK FOOTER //
// ./src/based/services/AccountServices.js